import React, { useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import 'moment/locale/ko'

// styles
import colors from '../../styles/colors'

function SelectPeriod({
  periodItem,
  setStartDate,
  setEndDate,
  selectedIndex,
  setSelectedIndex,
}) {
  const onSetDate = (flag) => {
    // moment.day(): 요일
    // 일 ~ 토: 0 ~ 6

    let start = null
    let end = null
    let today = moment().day()

    switch (flag) {
      // 오늘
      case 0:
        start = moment().format('YYYY-MM-DD')
        end = moment().format('YYYY-MM-DD')
        break

      // 이번주
      case 1:
        // // 선택 날짜가 월요일이면 시작일
        // if (today === 1) {
        //   start = moment().format('YYYY-MM-DD')
        //   end = moment().add(6, 'd').format('YYYY-MM-DD')
        // }
        // // 선택 날짜가 일요일이면 종료일
        // else if (today === 6) {
        //   start = moment().subtract(6, 'd').format('YYYY-MM-DD')
        //   end = moment().format('YYYY-MM-DD')
        // }
        // // 나머지
        // else {
        //   start = moment().subtract(1, 'd').format('YYYY-MM-DD')
        //   end = moment()
        //     .add(7 - today, 'd')
        //     .format('YYYY-MM-DD')
        // }
        start = moment().startOf('week').add(1, 'd').format('YYYY-MM-DD')
        end = moment().endOf('week').add(1, 'd').format('YYYY-MM-DD')

        break

      // 30일
      case 2:
        start = moment().subtract(30, 'd').format('YYYY-MM-DD')
        end = moment().format('YYYY-MM-DD')

        break

      // 분기
      // case 3:
      //   start = `${moment().format('Q')}분기`

      //   break

      // 날짜
      // case 4:
      //   start = moment().format('YYYY-MM-DD')
      //   end = moment().format('YYYY-MM-DD')
      //   break

      default:
        break
    }

    if (start) setStartDate(start)
    if (end) setEndDate(end)
  }

  return (
    <SelectWrapper>
      {periodItem &&
        periodItem.map((item, idx) => (
          <ItemSelect
            key={idx}
            isSelect={selectedIndex === idx}
            onClick={() => {
              if (periodItem.length > 1) {
                setSelectedIndex(idx)
                onSetDate(idx)
              }
            }}
          >
            {item.name}
          </ItemSelect>
        ))}
    </SelectWrapper>
  )
}

export default SelectPeriod

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`

const ItemSelect = styled.div`
  padding: 6px 15px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  font-size: 14px;
  color: ${(props) => (props.isSelect ? `${colors.W1}` : `${colors.G4}`)};
  background-color: ${(props) =>
    props.isSelect ? `${colors.mainG}` : `${colors.G3}`};

  &:hover {
    background-color: ${colors.mainG};
    color: white;
    cursor: pointer;
  }

  @media ${(props) => props.theme.mobile} {
    margin-right: 9px;
    padding: 6px;
    min-width: 44px;
  }
`
